<template>
  <section class="bank-ranking-list">
    <stores-filters
      class="bank-ranking-list-filters"
      scrollable
    />

    <ul class="bank-ranking-list-items">
      <simple-list-item
        v-for="(store) in list"
        :key="store.id"
        :item="store"
      />

      <context-state
        :state="currentState"
        tag="li"
      >
        <template v-slot:loading>
          Carregando lojas...
        </template>

        <template v-slot:notfound>
          Nenhuma loja encontrada :(
        </template>

        <template v-slot:empty>
          Sem mais lojas
        </template>
      </context-state>
    </ul>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import mobile from '@sdk/helpers/interface/mobile';
  import { alphabetical } from '@cordel/helpers/form/select/options';

  import ContextState from '@cordel/components/Context/State.vue';
  import SimpleListItem from '@cordel/components/List/Simple.vue';

  import StoresFilters from '@sdk/components/Filters/Stores/List.vue';

  export default {
    name: 'BankRankingList',
    components: {
      ContextState,
      SimpleListItem,

      StoresFilters,
    },
    mixins: [
      mobile,
    ],
    computed: {
      ...mapState([
        'stores',
      ]),

      filters() {
        return this.stores.list.filters;
      },
      list() {
        return Object
          .values(this.stores.list.items)
          .map(store => ({
            title: store.name,
            value: store.id,
            href: this.$router.resolve({
              name: 'settings-bank-ranking-form',
              params: {
                id: store.id,
              },
            }).href,
          }))
          .sort((a, b) => alphabetical(a.title, b.title));
      },
      loading() {
        return this.stores.list.loading;
      },
      currentState() {
        if (this.loading) {
          return 'loading';
        }

        if (this.error) {
          return 'error';
        }

        if (this.list.length === 0) {
          return 'notfound';
        }

        return 'empty';
      },
    },

    methods: {
      link(store) {
        return {
          name: 'settings-bank-ranking-form',
          params: {
            id: store.id,
          },
        };
      },
    },
  };
</script>

<style lang="scss">
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .bank-ranking-list-filters {
    .cordel-section-item {
      margin-top: 0;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .bank-ranking-list-items {
    list-style: none;
    margin-top: var(--cordel-spacing-xl);
  }
</style>
